import React, { FunctionComponent } from "react";
import { NodeProps } from "reactflow";
import {
  BasicNodeLayout,
  DocumentSchemaSource,
  IoType,
  NodeSize,
  NodeType,
  NodeTypeCategory,
  NodeOperationIcon
} from "../Base";
import { NodeConfigPropertyType } from "../../FlowDocument/PropertyTypeDefinitions";
import { DataType } from "../TypeDefinitions";
import { noReferenceSchemaId } from "../DataSchemas";

globalThis.nodeTypeDefinitions.setDefinition({
  nodeType: NodeType.callCustomObjectDelete,
  label: "Delete Custom Object Data",
  operationIcon: NodeOperationIcon.delete,
  category: NodeTypeCategory.services,
  size: NodeSize.Small,
  controlInputs: [{ name: "call" }],
  controlOutputs: [{ name: "completed", label: "" }],
  dataInputs: [{ name: "identifier", label: "ID", type: DataType.OBJECTREFERENCE, schemaId: noReferenceSchemaId }],
  dataOutputs: [],
  nodeConfigProperties: [
    {
      name: "customObjectId",
      label: "Custom Object",
      propertyType: NodeConfigPropertyType.CustomObject,
      schemaSourceSystemType: DocumentSchemaSource.customObject,
      schemaSystem: { createIo: true, ioType: IoType.delete }
    },
    {
      name: "customObjectName",
      label: "Custom Object Name",
      propertyType: NodeConfigPropertyType.NoInput,
      schemaSourceSystemType: DocumentSchemaSource.customObject
    }
  ],
  skipEvaluate: true,
  evaluate: () => {
    return { output: {}, activeControlHandleIds: [] };
  }
});

export const CallCustomObjectDeleteNode: FunctionComponent<NodeProps> = ({ id, data }) => {
  let label = "Delete Custom Object Data";
  if (data.nodeProperties.customObjectName) {
    label = `Delete ${data.nodeProperties.customObjectName} Custom Object Data`;
    data.nodeProperties.label = label;
  }
  return <BasicNodeLayout id={id} data={data} label={label} />;
};
